<style scoped>
</style>

<template>
	<v-expansion-panel>
		<v-expansion-panel-header class="blue--text">
			Contacts
		</v-expansion-panel-header>
		<v-expansion-panel-content>
			<v-row no-gutters>
				<v-skeleton-loader
					v-if="loading"
					type="list-item-two-line"
				/>
				<v-col cols="12" md="6" class="pa-1"
					v-for="contact in contacts"
					v-bind:key="contact.id"
				>
					<!-- <v-card @click="click_contact(contact)"> -->
					<v-card
						outlined
						elevation="0"
					>
						<div @click="click_contact(contact)">
							<v-row no-gutters>
								<v-col cols="2" class="pa-3">
									<div class="pl-3 pr-3">
										<v-user-avatar
											v-if="contact.id > 0"
											color="#00AAFD"
											class="font-weight-light"
											:code="contact.display_name"
											:image="'/api/addressbook/' + contact.abook_id + '/image.png'"
										/>
									</div>
								</v-col>
								<v-col cols="10" class="pa-3">
									<div class="text-caption pb-1" v-if = "contact.position!=''">{{contact.position}}</div>
									<div 
										class="
											text-xl-h6
											text-lg-h6 
											text-md-subtitle-1 
											text-sm-body-1 
											text-body-1 
											font-weight-light"
									>
										{{contact.display_name}}
									</div>
									<div class="text-body-2"><a :href="`mailto:${contact.main_email}`">{{contact.main_email}}</a></div>
								</v-col>
								<v-col cols="2"></v-col>
								<v-col cols="5" class="pl-3 pb-3" v-if = "contact.main_telephone!=''"> 
									<div class="text-caption grey--text">Main</div>
									<div class="text-body-2"><a :href="`tel:${contact.main_telephone}`">{{contact.main_telephone}}</a></div>
								</v-col>
								<v-col cols="5" class="pr-3 pb-3" v-if = "contact.main_mobile!=''"> 
									<div class="text-caption grey--text">Mobile</div>
									<div class="text-body-2"><a :href="`tel:${contact.main_mobile}`">{{contact.main_mobile}}</a></div>
								</v-col>
							</v-row>
						</div>
						<!--<div class="d-flex flex-no-wrap justify-space-between">
							<div class="pa-4">
								<div @click="click_contact(contact)">
									<v-user-avatar
										v-if="contact.id > 0"
										size="80"
										color="#00AAFD"
										class="text-h5 font-weight-light"
										:code="contact.display_name"
										:image="'/api/addressbook/' + contact.abook_id + '/image.png'"
										left
									/>
									<span class="pl-2"><b>{{contact.display_name}}</b></span>						
									<v-subheader>{{contact.position}}</v-subheader>
								</div>						
								<div class="ml-2">
									<span class="text-caption font-weight-light">Email:	</span>
									<span>
										<a :href="`mailto:${contact.main_email}`">{{contact.main_email}}</a>
									</span>
								</div>
								<div class="ml-2">
									<span class="text-caption font-weight-light">Telephone:	</span>
									<span >
										<a :href="`tel:${contact.main_telephone}`">{{contact.main_telephone}}</a>
									</span>	
								</div>
								<div class="ml-2">
								
									<span class="text-caption font-weight-light">Mobile:	</span>
									<span>
										<a :href="`tel:${contact.main_mobile}`">{{contact.main_mobile}}</a>
									</span>
								</div>
							</div>	
						</div>-->
					</v-card>

				</v-col>
			</v-row>
		</v-expansion-panel-content>
		
	</v-expansion-panel>
</template>

<script>
export default {
	props: {
		is_expanded: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			abook_id: 0,
			errormsg: '',
			loading: false,
			is_loaded: false,
			contacts:[]
		}
	},
	methods: {
		load(abook_id) {
			// load our contactrs
			this.abook_id = abook_id;
			if (this.is_expanded) {
				this.do_search()
			} else {
				this.is_loaded = false;
			}

		},
		do_search() {
			this.is_loaded = true;

			let self = this;
			this.errormsg = '';
			this.loading = true;
			this.contacts = [];

			// load our addressbook
			let url = "/api/addressbook/" + this.abook_id + "/contacts";
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						self.contacts = json.data;
						// console.log(self.contacts.length);
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading = false;
				});
		},
		click_contact(contact) {
			// this.$router.push("/addressbook/entry/" + contact.abook_id);
			this.$router.push({ name: "View Addressbook", params: { id:  contact.abook_id }});
		}
	},
	watch: {
		'is_expanded': function(new_value) {
			if (new_value && !this.is_loaded) {
				this.do_search();
			}
		}
	}
}
</script>
